import React, { ReactNode, useState } from "react";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import {
  formatarValorMonetario,
  formatarDataString,
  formatarDataStringParaMesAno,
} from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { CheckBox } from "shared/components/checkbox/CheckBox";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { Tooltip } from "antd";
import { FaEye, FaHandshake } from "react-icons/fa";
import ModalVisualizarContaReceber from "./ModalVisualizarContaReceber";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";
import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";

interface RenderRowsProps {
  opcaoSelecionadaCheckBox: OpcoesSelecionaveisCheckBox;
  idsCobrancasSelecionadas: number[];
  onSelecionarCobranca: (cobranca: RegistroContaReceberDTO) => void;
  onDesmarcarCobranca: (cobranca: RegistroContaReceberDTO) => void;
}

export const RenderRowsCobrancasEmAbertoProcessoJudicial: React.FC<RenderRowsProps> = (props) => {
  const [showModalVisualizarCobranca, setShowModalVisualizarCobranca] = useState(false);
  const [contaReceberId, setContaReceberId] = useState<number>();

  const { registrosTabelaModalSelecionarCobrancas: cobrancasPage } = useProcessosJudiciaisContext();

  const renderRegistros = (): ReactNode => {
    return cobrancasPage?.content.map((cobranca, index) => {
      const isChecked =
        props.opcaoSelecionadaCheckBox === "TODAS_FILTRO" || props.idsCobrancasSelecionadas.includes(cobranca.id);

      return (
        <LinhaTabela
          isSelecionada={isChecked}
          id={`id-registro-cobrancas-${index}`}
          key={`key-registro-cobrancas-${index}`}
        >
          <RegistroTabela
            isCheckBox
            id={`check-box-cobrancas-${cobranca.id}`}
            key={`check-box-cobrancas-${cobranca.id}`}
          >
            <CheckBox
              id={`check-box-${cobranca.id}`}
              usarValidacaoParaFormulario={false}
              key={`check-box-${cobranca.id}`}
              disabled={props.opcaoSelecionadaCheckBox === "TODAS_FILTRO"}
              checked={
                props.opcaoSelecionadaCheckBox === "TODAS_FILTRO" ||
                props.idsCobrancasSelecionadas.includes(cobranca.id)
              }
              onChange={(checked: boolean) => {
                checked ? props.onSelecionarCobranca(cobranca) : props.onDesmarcarCobranca(cobranca);
              }}
            />
          </RegistroTabela>

          <RegistroTabela id={`mes-competencia-${cobranca.id}`} key={`mes-competencia-${cobranca.id}`}>
            <span>{formatarDataStringParaMesAno(cobranca.mesCompetencia)}</span>
          </RegistroTabela>

          <RegistroTabela id={`nosso-numero-cobranca-${cobranca.id}`} key={`nosso-numero-cobranca-${cobranca.id}`}>
            <span>{cobranca.nossoNumero ? cobranca.nossoNumero : "-"}</span>
          </RegistroTabela>

          <RegistroTabela id={`vencimento-cobranca-${cobranca.id}`} key={`vencimento-cobranca-${cobranca.id}`}>
            <span>{formatarDataString(cobranca.dataVencimento)}</span>
          </RegistroTabela>

          <RegistroTabela id={`valor-cobranca-${cobranca.id}`} key={`valor-cobranca-${cobranca.id}`}>
            <span>{formatarValorMonetario(cobranca.valor)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`acoes-selecionar-cobranca-${cobranca.id}`}
            key={`acoes-selecionar-cobranca-${cobranca.id}`}
          >
            {cobranca.isAcordo && (
              <Tooltip title={cobranca.descricaoAcordo} placement="top">
                <a>
                  <FaHandshake className="me-2" size={17} color="#a69ae7" />
                </a>
              </Tooltip>
            )}
            <Tooltip title="Visualizar cobrança" placement="top">
              <a>
                <FaEye
                  className="cursor-pointer"
                  onClick={() => {
                    setContaReceberId(cobranca.id);
                    setShowModalVisualizarCobranca(true);
                  }}
                  size={17}
                  color="#a69ae7"
                />
              </a>
            </Tooltip>
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };

  return (
    <>
      {cobrancasPage?.content && cobrancasPage.content.length > 0 && renderRegistros()}
      {contaReceberId && (
        <ModalVisualizarContaReceber
          closeModal={() => setShowModalVisualizarCobranca(false)}
          showModal={showModalVisualizarCobranca}
          contaReceberId={contaReceberId}
        />
      )}
    </>
  );
};
